import { createSlice } from '@reduxjs/toolkit';
import { StoreStatus, KeyValues } from '../../core/types/common.types';
import { fetchTotalsThunk } from './thunks';

export interface TotalsState {
  errors: any;
  result: any;
  status: StoreStatus;
  values: KeyValues | null;
}

// Initial State
export const initialState: TotalsState = {
  status: StoreStatus.IDLE,
  values: null,
  result: null,
  errors: null,
};

// Slice
export const totalsSlice = createSlice({
  name: 'totals',
  initialState,
  reducers: {
    resetTotalsResult: (state: TotalsState) => ({
      ...state,
      status: initialState.status,
      errors: initialState.errors,
      result: initialState.result,
    }),
    resetTotals: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTotalsThunk.pending.type, (state: TotalsState) => {
      state.status = StoreStatus.BUSY;
      state.errors = null;
    });
    builder.addCase(fetchTotalsThunk.fulfilled.type, (state: TotalsState, action: any) => {
      state.result = action.payload;
      state.status = StoreStatus.IDLE;
    });
    builder.addCase(fetchTotalsThunk.rejected.type, (state: TotalsState, action: any) => {
      state.result = null;
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
    });
  },
});

// Action Creators
export * from './thunks';
export * from './selectors';
export const { resetTotalsResult, resetTotals } = totalsSlice.actions;
export default totalsSlice.reducer;
